import { scopedApi } from '@/session/scopedClients';
import type { RequestScope } from '@/session/scopedTransport';
import { DBRecurringImport } from '../../types/import';
import { EndpointResponse } from '../../types/endpoints';
import { utils } from '../../utils';
import type { ReadRequestOptions } from '../requestOptions';

const validate = (recurringImportId: number) => {
  if (!recurringImportId) {
    throw new Error('`recurringImportId` is required');
  }
};

type RequestParams = {
  recurringImportId: number;
};

type Response = DBRecurringImport;

export const getRecurringImportById = async (
  scope: RequestScope,
  { recurringImportId }: RequestParams,
  requestOptions: ReadRequestOptions
): Promise<EndpointResponse<Response>> => {
  try {
    validate(recurringImportId);

    const result = await scopedApi(scope).get<EndpointResponse<Response>>(`recurring_import/${recurringImportId}`, requestOptions);

    return result.data;
  } catch (e) {
    return utils.error.handleAxiosError(e);
  }
};
